import { Injectable } from '@angular/core';

import { BetBuilderProvider } from '@cds/betting-offer/add-ons';
import { EventDetailsConfig } from '@frontend/sports/common/client-config-data-access';
import { LocalStoreService } from '@frontend/vanilla/core';

@Injectable({
    providedIn: 'root',
})
export class EventInfoToolTipService {
    constructor(
        private eventDetailsConfig: EventDetailsConfig,
        private localStoreService: LocalStoreService,
    ) {}

    private localKeyAngstromLive = 'home-lobby-tooltip-angstrom-live';

    shouldShowLiveSgpTooltip(provider: BetBuilderProvider | undefined, leagueId: number): boolean {
        if (provider !== BetBuilderProvider.Angstrom) {
            return false;
        }

        const threshold = this.eventDetailsConfig?.liveSgpTooltipViewsThreshold?.[leagueId.toString()];
        return threshold ? this.tooltipAnsgtromLiveSgpShownCount < threshold : false;
    }

    private get tooltipAnsgtromLiveSgpShownCount(): number {
        return this.localStoreService.get<number>(this.localKeyAngstromLive) ?? 0;
    }

    closeAngstromLiveSgpTooltip(leagueId: number): void {
        const key = leagueId.toString();
        const threshold = this.eventDetailsConfig.liveSgpTooltipViewsThreshold?.[key];

        if (threshold) {
            this.localStoreService.set(this.localKeyAngstromLive, threshold + 1);
        }
    }
}
